<app-theme-menu [themeMenuOptions]="themeMenuOptions$ | async" (themeChangeEvent)="themeChangeHandler($event)"></app-theme-menu>